import React, { useEffect } from "react"
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from "react-router-dom";
import DefaultPreviewPdfFile from "../../components/default-preview-pdf-file";
import { useDetalhesDiarioOficialController } from "./context/detalhes-diario-oficial-controller";
import { useDetalhesDiarioOficialState } from "./context/detalhes-diario-oficial-context";
import dayjs from "dayjs";

export const DetalhesDiarioOficial = () => {

    const { loadData} = useDetalhesDiarioOficialController();
    const {officialDiaryDetailResponse } = useDetalhesDiarioOficialState();
    const { officialDailyId } = useParams();

    useEffect(() => {
        (async () => {
              await loadData(Number(officialDailyId));
        })();
    },[]);

   
    return (

        <React.Fragment>

        <Grid item xs={7} md={7} lg={7}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column'
                }} elevation={3}
            >
                <DefaultPreviewPdfFile fileUrl={officialDiaryDetailResponse?.fileUrl}></DefaultPreviewPdfFile>
            </Paper>
        </Grid>
        <Grid item xs={5} md={5} lg={5}>
            <Paper
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column'
                }} elevation={3}
            >
                <Grid container spacing={2}>
                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>Nº Edição</InputLabel>
                        <OutlinedInput
                            disabled
                            value={officialDiaryDetailResponse?.editionNumber}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>Ano</InputLabel>
                        <OutlinedInput
                            disabled
                            value={officialDiaryDetailResponse?.yearPublication}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Data da Edição</InputLabel>
                        <OutlinedInput
                            disabled
                            value={dayjs(officialDiaryDetailResponse?.publicationDate).format("DD/MM/YYYY")}
                            fullWidth
                        />
                    </Grid>

                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Fechada em</InputLabel>
                        <OutlinedInput
                            disabled
                            value={officialDiaryDetailResponse?.closedOn !== null && officialDiaryDetailResponse?.closedOn !== undefined ? dayjs(officialDiaryDetailResponse?.closedOn).format("DD/MM/YYYY HH:mm:ss") : null}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <InputLabel>Fechada por</InputLabel>
                        <OutlinedInput
                            disabled
                            value={officialDiaryDetailResponse?.closedByUser}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <InputLabel>Entidade</InputLabel>
                        <OutlinedInput
                            disabled
                            value={officialDiaryDetailResponse?.clientName}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <InputLabel>Descrição</InputLabel>
                        <OutlinedInput
                            disabled
                            multiline
                            rows={15}
                            value={officialDiaryDetailResponse?.descriptions}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                        sx={{ textAlign: 'right' }}
                    >
                        <ToggleButtonGroup
                            color="primary"
                            value={officialDiaryDetailResponse?.isClosed}
                            sx={{ mr: 2 }}
                        >
                            <ToggleButton value={true}>Fechada</ToggleButton>
                            <ToggleButton value={false}>Aberta</ToggleButton>
                        </ToggleButtonGroup>

                        {/* <ToggleButtonGroup
                            color="primary"
                            value={officialDiaryDetailResponse?.isVisibility}
                        >
                            <ToggleButton value={true}>Visível</ToggleButton>
                            <ToggleButton value={false}>Invisível</ToggleButton>
                        </ToggleButtonGroup> */}
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </React.Fragment>
    )
}